var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var pageStyle = {
    background: "#F8FAFC",
    color: "#28272C",
    minHeight: "calc(100vh - 320px)",
    padding: "24px clamp(16px, 7.8vw, 112px) 156px",
    width: "100%",
};
export var contentStyle = {
    display: "grid",
    gap: 60,
    margin: "0 auto",
    maxWidth: 1216,
    width: "100%",
};
export var headerStyle = {
    display: "grid",
    gap: 16,
};
export var titleStyle = {
    color: "#28272C",
    fontSize: 24,
    fontWeight: 700,
    letterSpacing: -0.15,
    lineHeight: 1.2,
    margin: 0,
};
export var descriptionStyle = {
    color: "#28272C",
    lineHeight: 1.5,
    margin: 0,
};
export var cardsGridStyle = {
    display: "grid",
    gap: 54,
    gridTemplateColumns: "repeat(auto-fit, minmax(min(100%, 320px), 384px))",
    justifyContent: "center",
    width: "100%",
};
export var contactCardStyle = {
    alignItems: "center",
    border: "1px solid #CED2D7",
    borderRadius: 8,
    display: "flex",
    flexDirection: "column",
    gap: 8,
    minHeight: 177,
    padding: 16,
    textAlign: "center",
};
export var iconContainerStyle = {
    alignItems: "center",
    background: "#E6F3FF",
    borderRadius: "50%",
    color: "#0034B7",
    display: "flex",
    height: 80,
    justifyContent: "center",
    width: 80,
};
export var iconStyle = {
    fontSize: 46,
};
export var valueStyle = {
    color: "#28272C",
    fontSize: 20,
    fontWeight: 700,
    letterSpacing: -0.15,
    lineHeight: 1.4,
    margin: 0,
    overflowWrap: "anywhere",
};
export var linkStyle = __assign(__assign({}, valueStyle), { color: "#337FFF", textDecoration: "underline" });
export var helperTextStyle = {
    color: "#28272C",
    fontSize: 14,
    lineHeight: 1.5,
    margin: 0,
};
